import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../../services/role.service';
import { Role } from '../../../models/role.model';
import { Authority } from '../../../models/authority.model';
import { FormValidators } from '../../../shared/validators/form.validators';


export interface RoleRequest {
  id: number;
  code: string;
  descr: string;
  authorities: string[];
}

@Component({
  selector: 'app-role-form',
  templateUrl: './role-form.component.html'
})
export class RoleFormComponent implements OnInit {

  roleForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  roleId: number;
  role: Role;
  authorityList: Authority[] = [];
  selectedAuthorities: Authority[] = [];

  constructor(
    private roleService: RoleService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder) {
      this.roleId = +this.route.snapshot.params.roleId;
      this.route.data.subscribe(data => {
        this.role = data.roleResolverResponse;
        this.authorityList = data.authorityListResolverResponse.content;
      });
    }

  ngOnInit() {
    this.buildForm();

    if (this.roleId) {
      this.getRole();
    }
  }

  private getRole() {
    this.roleService.getRole(this.roleId).subscribe(role => {
      this.role = role;
      this.selectedAuthorities = role.authorities;
      this.authorityList = this.authorityList.filter(item => !this.selectedAuthorities.map(it => it.authority).includes(item.authority));
      this.roleForm.patchValue({
        id: role.id,
        code: role.code,
        descr: role.descr,
        authorities: role.authorities.map(item => item.authority)
      });
      this.roleForm.get('code').setValidators(null);
      this.roleForm.get('code').updateValueAndValidity();
    });
  }

  private buildForm() {
    this.roleForm = this.formBuilder.group({
      id: new FormControl(null),
      code: new FormControl(null, [Validators.required, FormValidators.codeValidator]),
      descr: new FormControl(null, [Validators.required]),
      authorities: new FormControl([])
    });
  }

  get f() { return this.roleForm.controls; }

  onAddAuthority(authority, index) {
    this.authorityList.splice(index, 1);
    this.selectedAuthorities.push(authority);
    this.roleForm.get('authorities').setValue(this.selectedAuthorities.map(item => item.authority));
  }

  onSubmit() {
    this.submitted = true;

    if (this.roleForm.invalid) {
        return;
    }

    this.saveRole();
  }

  private saveRole() {
    if (!this.roleId) {
      this.createRole();
    } else {
      this.updateRole();
    }
  }

  onRemoveAuthority(authority, index) {
    this.authorityList.push(authority);
    this.selectedAuthorities.splice(index, 1);
    this.roleForm.get('authorities').setValue(this.selectedAuthorities.map(item => item.authority));
  }

  private createRole() {
    const roleRequest = Object.assign(this.roleForm.value, {
      code: `ROLE_${this.roleForm.value.code}`
    });
    this.roleService.createRole(roleRequest).subscribe(res => {
      this.router.navigate(['../'], {relativeTo: this.route});
    });
  }

  private updateRole() {
    this.roleService.updateRole(this.roleId, this.roleForm.value).subscribe();
  }
}
